// 261015 P4c-1 (D3) — ngăn kéo "xem trích": ý + trạng thái + CHỮ GỐC nguyên tác (chương N). Portal ngoài `.wb` ⇒ không dùng token `--wb-*`, style trung tính chạy cả sáng/tối.
import React from 'react';
import { Button, Drawer, Space, Tag, Typography } from 'antd';
import type { EvidenceView } from './overviewView';

const { Text, Paragraph } = Typography;
const quoteStyle: React.CSSProperties = { borderLeft: '3px solid rgba(127,127,127,.55)', padding: '6px 12px', margin: '8px 0', background: 'rgba(127,127,127,.1)', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' };

interface Props {
  open: boolean;
  evidence: EvidenceView | null;
  onClose: () => void;
  canEdit: boolean;
  onEdit: (claimId: string) => void;
  onAsk: (claimId: string, text: string) => void;
}

const EvidenceDrawer: React.FC<Props> = ({ open, evidence, onClose, canEdit, onEdit, onAsk }) => (
  <Drawer title={evidence ? `Trích nguồn của ý ${evidence.claimId}` : 'Trích nguồn'} open={open} onClose={onClose} size={520} destroyOnHidden>
    {evidence ? (
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        <Space wrap>
          <Tag color={evidence.tone === 'ok' ? 'green' : evidence.tone === 'warn' ? 'orange' : 'red'}>{evidence.statusText}</Tag>
          <Text type="secondary">{evidence.originText}</Text>
        </Space>
        <Paragraph style={{ marginBottom: 0 }}><Text strong>Ý đang dùng: </Text>{evidence.text}</Paragraph>
        {evidence.reason && <Text type="danger">{evidence.reason}</Text>}
        {evidence.quotes.length === 0 && <Text type="secondary">Chưa có trích nào được định vị trong nguyên tác.</Text>}
        {evidence.quotes.map((q) => (
          <div key={q.anchorId}>
            <Text type="secondary" style={{ fontSize: 13 }}>Chương {q.chapter} · nguyên văn nguồn</Text>
            <div style={quoteStyle} lang="und">{q.quote}</div>
          </div>
        ))}
        {evidence.unlocated.length > 0 && (
          <div>
            <Text type="warning">Trích bạn/AI đưa nhưng không tìm thấy trong nguyên tác:</Text>
            {evidence.unlocated.map((q, i) => <div key={i} style={{ ...quoteStyle, borderLeftColor: 'rgba(250,140,22,.8)' }}>{q}</div>)}
          </div>
        )}
        <Text type="secondary" style={{ fontSize: 13 }}>{evidence.honesty}</Text>
        {canEdit && (
          <Space wrap>
            <Button size="small" onClick={() => onEdit(evidence.claimId)}>Sửa ý và trích dẫn</Button>
            <Button size="small" onClick={() => onAsk(evidence.claimId, evidence.text)}>Nhờ trợ lý sửa ý này</Button>
          </Space>
        )}
      </Space>
    ) : null}
  </Drawer>
);

export default EvidenceDrawer;
